var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"ea-click",rawName:"v-ea-click",value:(function () { _vm.$router.go(-1) }),expression:"() => { $router.go(-1) }"}],staticClass:"btn",attrs:{"type":"button"}},[_c('arrow-left-icon',{attrs:{"size":"1.5x"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }